import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { CreateTimesheetStatusRequest, TimesheetStatusService, UpdateTimesheetStatusRequest } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class TimesheetStatusCommandService {
  private readonly timesheetStatusService = inject(TimesheetStatusService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateTimesheetStatusRequest) =>
      lastValueFrom(this.timesheetStatusService.createTimesheetStatus(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_STATUSES] });
    },
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateTimesheetStatusRequest }) =>
      lastValueFrom(this.timesheetStatusService.updateTimesheetStatus(request.id, request.body)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_STATUSES] });
    },
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) =>
      lastValueFrom(this.timesheetStatusService.deleteTimesheetStatus(id)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_STATUSES] });
    },
  }));
}
